import { getFullVariant } from '@wetransfer/transfer/modules/experiments';

class TransferUploadCompleteNotificationsExperiment {
  static key = 'transfer-upload-complete-notifications';

  static variations = {
    default: 'control',
    treatment: 'notification-opt-in-displayed',
  };

  static isControl(): boolean {
    return this.currentVariant() === this.variations.default;
  }

  static isEnabled(): boolean {
    return (
      typeof window !== 'undefined' &&
      !window.matchMedia('(pointer: coarse)').matches &&
      this.currentVariant() === this.variations.treatment
    );
  }

  static currentVariant(): string {
    return getFullVariant(this.key, {
      value: this.variations.default,
    }).value;
  }
}

export default TransferUploadCompleteNotificationsExperiment;
